import React from "react";
import { cn } from "@/lib/utils";

export const SectionLabel = ({ children, tone = "orange", className = "" }) => (
  <div
    className={cn(
      "text-[11px] font-medium tracking-[0.28em] uppercase",
      tone === "orange" && "text-[hsl(var(--brp-orange))]",
      tone === "blue" && "text-[hsl(var(--brp-blue))]",
      tone === "muted" && "text-[hsl(var(--brp-ink-dim))]",
      className
    )}
  >
    {children}
  </div>
);

export const SectionTitle = ({ children, className = "", size = "lg" }) => (
  <h2
    className={cn(
      "font-display font-semibold tracking-[-0.02em]",
      size === "xl" && "text-3xl sm:text-4xl lg:text-5xl",
      size === "lg" && "text-2xl sm:text-3xl lg:text-4xl",
      size === "md" && "text-2xl sm:text-3xl",
      className
    )}
  >
    {children}
  </h2>
);

export const Section = ({ children, className = "", tone = "dark", py = "lg" }) => {
  return (
    <section
      className={cn(
        "relative",
        tone === "paper" && "brp-paper",
        py === "lg" && "py-16 sm:py-20 lg:py-28",
        py === "md" && "py-12 sm:py-16 lg:py-20",
        py === "sm" && "py-10 sm:py-12 lg:py-16",
        className
      )}
    >
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8 lg:px-10">{children}</div>
    </section>
  );
};
